<template>
    <div v-if="errorMessage" class="error-message">
        <WarningIcon width="20px" height="20px"></WarningIcon>
        {{ errorMessage }}
    </div>
</template>

<script setup lang="ts">
import WarningIcon from '@/icons/Warning.vue';

defineProps<{ 
	errorMessage: string;
}>()
</script>